import { Helmet } from "react-helmet-async";
import { defaultSEO } from "../utils/seo";

const SEOHead = ({ title, description, keywords, image, url, canonical, schema }) => {
  const finalTitle = title || defaultSEO.title;
  const finalDescription = description || defaultSEO.description;
  const finalKeywords = keywords || defaultSEO.keywords;
  const finalCanonical = canonical || url;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:type" content="website" />
      {image && <meta property="og:image" content={image} />}
      {finalCanonical && <meta property="og:url" content={finalCanonical} />}
      {finalCanonical && <link rel="canonical" href={finalCanonical} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      {schema && (
        <script type="application/ld+json">
          {typeof schema === "string" ? schema : JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;